import axiosInstance from '@/utils/api.js'

var state = {
  dynamicShapingServices: [],
  dynamicShaping: []
}

var getters = {
  DYNAMIC_SHAPING_SERVICES: (state) => {
    return state.dynamicShapingServices
  },
  DYNAMIC_SHAPING: (state) => {
    return state.dynamicShaping
  }
}

var mutations = {
  SET_DYNAMIC_SHAPING_SERVICES: (state, payload) => {
    state.dynamicShapingServices = payload
  },
  SET_DYNAMIC_SHAPING: (state, payload) => {
    state.dynamicShaping = payload
  }
}

var actions = {
  GET_DYNAMIC_SHAPING_SERVICES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/shaping_services')
    if (result.status === 200) {
      context.commit('SET_DYNAMIC_SHAPING_SERVICES', result.data)
    }
  },
  GET_DYNAMIC_SHAPING: async (context, payload) => {
    let result = await axiosInstance.get('/settings/shaping?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_DYNAMIC_SHAPING', result.data)
    }
  },
  DELETE_DYNAMIC_SHAPING: (context, payload) => {
    return axiosInstance.delete('/settings/shaping?shaping_id=' + payload)
  },
  CREATE_DYNAMIC_SHAPING: (context, payload) => {
    return axiosInstance.post('/settings/shaping', payload)
  },
  UPDATE_DYNAMIC_SHAPING: (context, payload) => {
    return axiosInstance.put('/settings/shaping', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/dynamicShaping.js